import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '@hm/environments/environment';

import { DoctorProfile, PersonalDoctor } from '@lib/core/models/doctor.interface';

import { AchiCode } from '@lib/shared-ui/core/models/achi-codes.interface';

@Injectable({ providedIn: 'root' })
export class DoctorsService {
  private readonly http = inject(HttpClient);

  getDoctors() {
    return this.http.get<DoctorProfile[]>(`${environment.healthManagerApiUrl}/doctors`);
  }

  getPersonalDoctors(userId?: string) {
    let params = new HttpParams();
    if (userId) {
      params = params.set("userId", userId);
    }

    return this.http.get<{ items: PersonalDoctor[] }>(`${environment.protectedApiUrl}/partners/users/personal-doctors`, { params });
  }

  updatePersonalDoctor(memberId: string, doctorId: string | null, partnerId: string | null): Observable<unknown> {
    return this.http.put<unknown>(`${environment.healthManagerApiUrl}/members/${memberId}/personal-doctor`, {
      doctorId: doctorId || null,
      partnerId: partnerId || null,
    });
  }

  getPersonalDoctorServices(userId?: string) {
    let params = new HttpParams();
    if (userId) {
      params = params.set("userId", userId);
    }

    const payload = {
      category: 'PersonalDoctor',
      pageSize: 10,
    };

    return this.http.post<{ items: AchiCode[] }>(`${environment.protectedApiUrl}/dictionaries/achi/search`, payload, { params });
  }
}
